import { render, staticRenderFns } from "./BasePanel.vue?vue&type=template&id=eed785cc&scoped=true&"
import script from "./BasePanel.vue?vue&type=script&lang=js&"
export * from "./BasePanel.vue?vue&type=script&lang=js&"
import style0 from "./BasePanel.vue?vue&type=style&index=0&id=eed785cc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eed785cc",
  null
  
)

export default component.exports